export const DEFAULT_PAGE_LIMIT = 20;
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_SORT_BY = 'name';
export const DEFAULT_SORT_ORDER = 'asc';
export const DEFAULT_SEARCH = '';
export const DEFAULT_BRAND_ID = '';
export const DEFAULT_GENERIC_ID = '';
export const DEFAULT_PRODUCT_ID = '';
export const DEFAULT_PRODUCT_VARIATION_ID = '';
